import { createStore } from 'vuex'

export default createStore({
	state: {
		windowWidth:1024,
		windowHeight:900,
		lang:'zh-cn',

		brand:'KF',
		userType:null,
		userInfo:{
			ID:null,
			DesignerName:null,
		},
		userAuthorities:[],
		userRank:{},
		shopList:[],
		kjlInfo:{},
		labelColours:[],

		auditerInfo:null,
		isAuditer:false,
		kdMagInfo:{},

		lk:null,
		tokens:[],
		curTime:null,

		auditDesignUrl:null,
	},
	getters: {
		hasKJL(state){
			if (!state.kjlInfo || !state.kjlInfo.UserName) 
				return false
			else 
				return true
		},
		enableSeeAllOrders(state){
			try {
				return state.userInfo.BossNum > 0 
					|| state.userInfo.Operator.SeeAllOrders 
					|| state.userAuthorities?.find(it=>it?.Module?.ModuleCode=="OrderingSystem" && it?.Operation?.OperationCode=="ReadAll")
			} catch (error) {
				return false;
			}
		},
		enablePlaceOrder(state){
			try {
				return state.userInfo.BossNum > 0 
					|| state.userInfo.Operator.PlaceOrder
					|| state.userAuthorities?.find(it=>it?.Module?.ModuleCode=="OrderingSystem" && it?.Operation?.OperationCode=="PlaceOrder")
				} 
			catch (error) {
				return false;
			}
		},
		enableQuote(state){
			try {
				return state.userInfo.BossNum > 0 
					|| state.userInfo.Operator.Quote
					|| state.userAuthorities?.find(it=>it?.Module?.ModuleCode=="OrderingSystem" && it?.Operation?.OperationCode=="Quote")
				} 
			catch (error) {
				return false;
			}
		}
	},
	mutations: {
		setWindowWidth(state, data){
			state.windowWidth=data;
		},
		setWindowHeight(state, data){
			state.windowHeight=data;
		},
		setLang(state, data){
			state.lang=data;
			localStorage.setItem('Language',data);
		},
		setBrand(state, data){
			state.brand=data;
		},
		setUserType(state, data){
			state.userType=data;
		},
		setUserInfo(state, data){
			state.userInfo=data;
		},
		setKjlInfo(state, data){
			state.kjlInfo=data;
		},
		setUserAuthorities(state, data){
			state.userAuthorities=data;
		},
		setAuditerInfo(state, data){
			state.auditerInfo=data;
			state.isAuditer=true;
		},
		setKdMagInfo(state, data){
			state.kdMagInfo=data;
		},
		setShopList(state, data){
			state.shopList=data;
		},
		setLabelColours(state, data){
			state.labelColours=data;
		},
		setLK(state,data){
			state.lk=data;
		},
		addTokens(state,t){
			state.tokens[t.time]=t.token;
			state.curTime = t.time;
			// console.log(state.tokens);
			
		},
		clearTokens(state){
			state.tokens=[];
		},
		setAuditDesignUrl(state,data){
			state.auditDesignUrl=data;
		},
		setUserRank(state,data){
			state.userRank=data;
		},
	},
	actions: {
	},
	modules: {
	}
})
